import React from "react";
import { Link } from "react-router-dom";
import { observer } from "mobx-react-lite";
import { store } from "../stores/Store";

interface HeaderProps {
  isAdminPage: boolean;
}

export const Header: React.FC<HeaderProps> = observer(({ isAdminPage }) => {
  const { formattedCartTotal, cartItemsCount } = store;

  return (
    <header id="cabecalho">
      <div className="logo_e_menu colored">
        <div>
          {/* Logo */}
          <h1 className="logo">
            <a href="/" title="Rabo de Galo Editora">
              Rabo de Galo Editora
            </a>
          </h1>

          {/* Menus */}
          {!isAdminPage && (
            <div className="menus">
              <Link to="/consultar_pedidos" className="bt_pedido mg-bt_10">
                Consultar Pedido
              </Link>
              <Link to="/carrinho" className="bt_carrinho">
                <span className="count">{cartItemsCount}</span>
                Ver Carrinho: {formattedCartTotal}
              </Link>
            </div>
          )}
        </div>
      </div>
    </header>
  );
});
